import { css } from 'styled-components';
export var typography = {
  lineClamp: function lineClamp() {
    var numLines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return css(["display:-webkit-box;-webkit-line-clamp:", ";-webkit-box-orient:vertical;overflow:hidden;"], numLines);
  }
};